export const NAME = 'selfPromotion';

export const RANKS = ['E4', 'E5', 'E6', 'E7'];
export const DUTY_STATES = ['Regular', 'Substitute', 'Reserve'];
